import { FC } from 'react'
import styles from './TruemedHIW.module.scss'
import { TruemedHIWProps, defaultSteps } from './TruemedHIW.types'
import { Img } from 'components/basic/Img'

const StepCard = (props: { eyebrow: string; title: string; content: string; imgurl: string }) => (
	<div className={styles.step_card}>
		<div className={styles.left}>
			<div className={styles.step_description}>
				<div className={styles.step_eyebrow}>{props.eyebrow}</div>
				<div className={styles.step_title}>{props.title}</div>
				<div className={styles.step_content}>{props.content}</div>
			</div>
		</div>
		<div className={styles.right}>
			<div className={styles.step_image}>
				<Img
					src={props.imgurl}
					alt={''}
				/>
			</div>
		</div>
	</div>
)
export const TruemedHIW: FC<TruemedHIWProps> = (props) => {
	const {} = props
	return (
		<div className={styles.container}>
			<div className={styles.hiw_wrapper}>
				<div className={styles.hiw_header}>
					<div className={styles.how_title}>How it works</div>
					<div className={styles.how_intro}>We've partnered with Truemed, enabling you to use your Health Savings Account (HSA) or Flexible Spending Account (FSA) to get up to 40% off the Pod.</div>
				</div>
				<div className={styles.step_wrapper}>
					{defaultSteps.map((step) => (
						<StepCard
							key={step.title}
							eyebrow={step.eyebrow}
							title={step.title}
							content={step.content}
							imgurl={step.url}
						/>
					))}
				</div>
			</div>
		</div>
	)
}
